import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			'& > *': {
				margin: 0,
			},
		},
		input: {
			display: 'none',
		},
		inactiveBudge: {
			background: 'white',
			color: '#78393D',
			borderRadius: 200,
			margin: '.2rem 0',
			padding: '.5rem .8rem',
			cursor: 'pointer',
			width: '40px',
		},
		activeBudge: {
			background: '#78393D',
			color: 'white',
			padding: '.5rem .8rem',
			borderRadius: 200,
			margin: '.2rem 0',
			cursor: 'pointer',
			width: '40px',
		},
		inactiveBg: {
			background: '#E6E6E6',
			borderRadius: 50,
			color: '#78393D',
			margin: '1rem 0',
			width: '50%',
			cursor: 'pointer',
			[theme.breakpoints.down('xs')]: {
				width: '100% !important',
			},
		},
		text: { fontFamily: 'Poppins', fontSize: '16px', margin: '0' },
		activeBg: {
			background: '#FDEF6D',
			borderRadius: 50,
			color: '#78393D',
			margin: '1rem 0',
			width: '50%',
			cursor: 'pointer',
			[theme.breakpoints.down('xs')]: {
				width: '100% !important',
			},
		},
		listItems: {
			listStyleType: 'none',
			margin: 0,
			padding: 0,
			[theme.breakpoints.down('xs')]: {
				background: '#F1F6FA',
				borderRadius: '2rem',
				padding: '2rem !important',
				fontSize: '16px',
			},
		},
		topImage: {
			display:'flex',
			margin:'0 auto',
			width: '70%',
			height: '473px',
			borderRadius: '10px',
			objectFit: 'contain',
			[theme.breakpoints.down('xs')]: {
				width: '90%',
			},
		},
	}),
);
